import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const LiebherrMairneEngine = () => {
    const [state, setState] = useState<number>(1)
    const {t} = useTranslation()
    const navigate = useNavigate()
    return(
        <>
        <div className="contentBox">
            <div className="tabBox">
                <div className="left">
                    <div>
                        <h3>
                            <span>LIEBHERR ENGINE:</span>
                            D976 Series
                        </h3>
                        
                        <ul className="tabBtnBox">
                            <li className={state === 1 ? 'active' : ''} onClick={()=>setState(1)}>{t("liebherr_1")}</li>
                            <li className={state === 2 ? 'active' : ''} onClick={()=>setState(2)}>{t("liebherr_2")}</li>
                        </ul>
                        {/* <!-- 탭 버튼 : 클릭시 active클래스 --> */}
                    </div>

                    <button className="moreViewBtn" onClick={()=>window.open('/LIEBHERR-ENGINE')}>3D Modeling</button>
                </div>
                <div className="right">
                    <div className="tabContentBox">
                        <div className={state === 1 ? "imgBox active" : 'imgBox'}>
                            <img src="/assets/images/d976_view_img.png" alt="D976 Series"/>
                        </div>
                        <div className={state === 2 ? "imgBox active" : 'imgBox'}>
                            <img src="/assets/images/d976_view_drawing.png" alt="D976 Series"/>
                        </div>
                    </div>
                    {/* <!-- 탭버튼에 따라 이미지 변경 --> */}
                </div>
            </div>

            <div className="tableWrap ships liebherr">
                <table>
                    <thead>
                        <tr>
                            <th>{t("liebherr_3")}</th>
                            <th className="width_140">{t("liebherr_4")}</th>
                            <th>D976</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>{t("liebherr_5")}</th>
                            <td></td>
                            <td>{t("liebherr_6")}</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_7")}</th>
                            <td></td>
                            <td>{t("liebherr_8")}</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_9")}</th>
                            <td></td>
                            <td>{t("liebherr_10")}</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_11")}</th>
                            <td></td>
                            <td>{t("liebherr_12")}</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_13")}</th>
                            <td>mm(in)</td>
                            <td>148 (5.83)</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_14")}</th>
                            <td>mm(in)</td>
                            <td>174 (6.85)</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_15")}</th>
                            <td>ℓ(in3)</td>
                            <td>17.9 (1,096)</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_16")}</th>
                            <td></td>
                            <td>16.5:1</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_17")}</th>
                            <td>PS(kW)</td>
                            <td>851 (626)</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_18")}</th>
                            <td>RPM</td>
                            <td>1900</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_19")}</th>
                            <td>Nm (lb-ft)</td>
                            <td>3,660 @1,300rpm (2,700 @1,300rpm)</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_20")}</th>
                            <td></td>
                            <td>IMO Tier 2</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_21")}</th>
                            <td></td>
                            <td>{t("liebherr_22")}</td>
                        </tr>
                        <tr>
                            <th rowSpan={2}>{t("liebherr_23")}</th>
                            <td>g/kWh</td>
                            <td>Rated : 210 / Best : 188</td>
                        </tr>
                        <tr>
                            <td>ℓ/hr</td>
                            <td>Rated : 157 / Best : 140</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_24")}</th>
                            <td>ℓ</td>
                            <td>70</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_25")}</th>
                            <td>ℓ</td>
                            <td>87</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_26")}</th>
                            <td></td>
                            <td>±25˚</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_27")}</th>
                            <td>V-KM</td>
                            <td>24-7.7</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_28")}</th>
                            <td>V-A</td>
                            <td>24-140</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_29")}</th>
                            <td></td>
                            <td>{t("liebherr_30")}</td>
                        </tr>
                        <tr>
                            <th>{t("liebherr_31")}</th>
                            <td>kg</td>
                            <td>2250</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </>
    )
}